<div class="log-cinematic-section-application">
    <ng-container *ngrxLet="applicationInfo$ as applicationInfo">
        <!-- Left column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.http2StreamIDLabel | vtranslate }}
            </div>
            <span
                *ngIf="applicationInfo.http2_stream_id as streamId; else na"
                logFilter
                property="http2_stream_id"
                [value]="streamId"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ streamId }}
            </span>

            <div logFieldTitle>{{ l10nKeys.serverPushInitiatedLabel | vtranslate }}</div>
            <span
                *ngIf="applicationInfo.server_push_initiated !== undefined; else na"
                logFilter
                property="server_push_initiated"
                [value]="applicationInfo.server_push_initiated"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ applicationInfo.server_push_initiated }}
            </span>

            <div logFieldTitle>{{ l10nKeys.serverPushedRequestLabel | vtranslate }}</div>
                <span
                    *ngIf="applicationInfo.server_pushed_request !== undefined; else na"
                    logFilter
                    property="server_pushed_request"
                    [value]="applicationInfo.server_pushed_request"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ applicationInfo.server_pushed_request }}
                </span>
        </div>

        <!-- Middle column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.cacheHitLabel | vtranslate }}
            </div>
            <ng-container *ngIf="applicationInfo.cache_hit !== undefined; else na">
                <span
                    logFilter
                    property="cache_hit"
                    [value]="applicationInfo.cache_hit"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ applicationInfo.cache_hit }}
                </span>
            </ng-container>

            <div logFieldTitle>{{ l10nKeys.compressionLabel | vtranslate }}</div>
            <ng-container *ngIf="(applicationInfo$ | async | logResponseCompressionInfo) as compressionInfo; else na">
                <span
                    *ngIf="compressionInfo.compressed"
                    logFilter
                    property="compression"
                    [value]="applicationInfo.compression"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ compressionInfo.compressed }}
                    <span
                        logFilterList
                        property="compression_percentage"
                        [value]="compressionInfo.compressionPercentage"
                        displayValue="{{ compressionInfo.compressionPercentage }} %"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        ({{ l10nKeys.compressedPercentageLabel | vtranslate : compressionInfo.compressionPercentage }})
                    </span>
                </span>
                <span
                    *ngIf="!compressionInfo.compressed"
                    logFilter
                    property="compression"
                    [value]="applicationInfo.compression"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ compressionInfo.noCompressionReason }}
                </span>
            </ng-container>
        </div>

        <!-- Right column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.numberOfServersTriedLabel | vtranslate }}
            </div>
            <span
                *ngIf="applicationInfo.servers_tried !== undefined; else na"
                logFilterList
                property="servers_tried"
                [value]="applicationInfo.servers_tried"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ applicationInfo.servers_tried }}
            </span>

            <div logFieldTitle>{{ globalL10nKeys.requestLabel | vtranslate }}</div>
            <span
                *ngIf="applicationInfo.method as method; else na"
                logFilter
                property="method"
                [value]="method"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ method }}
            </span>
        </div>
    </ng-container>
</div>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>
